import {IconNavigation} from '@tabler/icons-react';
import {ActionIcon} from 'src/design/atoms/ActionIcon';
import type {ActionIconProps} from 'src/design/atoms/ActionIcon';

/**
 * Large filled "navigate" action icon — thin `ActionIcon` wrapper with a
 * navigation-arrow glyph, `color="yellow"`, `size={50}`, `radius="xl"`,
 * `variant="filled"`.
 * @registry Large filled circular navigation action, e.g. map/wayfinding
 * controls.
 *
 * Ported from `library-m/components/action-icons/NavigationActionIcon`.
 * Prop surface kept identical (all `ActionIcon` props pass through).
 */
export type NavigationActionIconProps = ActionIconProps;

export const NavigationActionIcon = ({
  color = 'yellow',
  size = 50,
  radius = 'xl',
  variant = 'filled',
  ...props
}: NavigationActionIconProps) => (
  <ActionIcon color={color} size={size} radius={radius} variant={variant} {...props}>
    <IconNavigation stroke={1.5} size={30} />
  </ActionIcon>
);
